function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M168.66 217.216l36.679-51.215M142.17 145.515L288.886 2.112 176.811 155.758",
  stroke: "#2E2677",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M79 122.98L288.886 2.112l-28.528 182.326-83.547-28.68-8.151 61.458-26.49-71.701L79 122.98z",
  stroke: "#2E2677",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M97.372 198.166l18.777-26.125M201.871 238.169l18.777-26.124M108.802 245.517l28.574-39.187",
  stroke: "#2E2677",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M378.838 1007c-122.338-75-166-228.5-199-268.5s-92.158-48.344-135-19c-45.26 31-53 86.5-31 128s85.874 80.153 143 32.5c116.896-97.511 45-275-10-362.5-43.504-69.212-60.338-174.5 0-264.5",
  stroke: "#2E2677",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeDasharray: "4 8"
});

function SvgContactUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 1009,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgxIiBoZWlnaHQ9IjEwMDkiIHZpZXdCb3g9IjAgMCAzODEgMTAwOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2OC42NiAyMTcuMjE2TDIwNS4zMzkgMTY2LjAwMSIgc3Ryb2tlPSIjMkUyNjc3IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQyLjE3IDE0NS41MTVMMjg4Ljg4NiAyLjExMTgyTDE3Ni44MTEgMTU1Ljc1OCIgc3Ryb2tlPSIjMkUyNjc3IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTc5IDEyMi45OEwyODguODg2IDIuMTExODJMMjYwLjM1OCAxODQuNDM4TDE3Ni44MTEgMTU1Ljc1OEwxNjguNjYgMjE3LjIxNkwxNDIuMTcgMTQ1LjUxNUw3OSAxMjIuOThaIiBzdHJva2U9IiMyRTI2NzciIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIG9wYWNpdHk9IjAuMiIgZD0iTTk3LjM3MjIgMTk4LjE2NkwxMTYuMTQ5IDE3Mi4wNDEiIHN0cm9rZT0iIzJFMjY3NyIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggb3BhY2l0eT0iMC4yIiBkPSJNMjAxLjg3MSAyMzguMTY5TDIyMC42NDggMjEyLjA0NSIgc3Ryb2tlPSIjMkUyNjc3IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBvcGFjaXR5PSIwLjIiIGQ9Ik0xMDguODAyIDI0NS41MTdMMTM3LjM3NiAyMDYuMzMiIHN0cm9rZT0iIzJFMjY3NyIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggb3BhY2l0eT0iMC4yIiBkPSJNMzc4LjgzOCAxMDA3QzI1Ni41IDkzMiAyMTIuODM4IDc3OC41IDE3OS44MzggNzM4LjVDMTQ2LjgzOCA2OTguNSA4Ny42ODAxIDY5MC4xNTYgNDQuODM4MSA3MTkuNUMtMC40MjE4MjUgNzUwLjUgLTguMTYxOCA4MDYgMTMuODM4MiA4NDcuNUMzNS44MzgyIDg4OSA5OS43MTIyIDkyNy42NTMgMTU2LjgzOCA4ODBDMjczLjczNCA3ODIuNDg5IDIwMS44MzggNjA1IDE0Ni44MzggNTE3LjVDMTAzLjMzNCA0NDguMjg4IDg2LjUgMzQzIDE0Ni44MzggMjUzIiBzdHJva2U9IiMyRTI2NzciIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtZGFzaGFycmF5PSI0IDgiLz4KPC9zdmc+Cg==";
export { SvgContactUs as ReactComponent };